var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import CenteredButton from '../CenteredButton';
import NavBar from '../NavBar';
import TextWithAudio from '../TextWithAudio';
import Video from '../Video/Video';

import { getNext, getPrevious } from '../../lib/getWithinMax';

import styles from './styles.less';

var slidePropTypes = {
  slide: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
    path: PropTypes.string.isRequired,
    type: PropTypes.string,
    scaling: PropTypes.string
  })
};

var Slide = function Slide(_ref) {
  var slide = _ref.slide;
  return React.createElement(
    'div',
    { className: styles.slide },
    slide.type === 'video' ? React.createElement(Video, { id: slide.id, src: slide.path }) : React.createElement(
      'div',
      { className: styles.imageContainer },
      slide.path && React.createElement('img', {
        src: slide.path,
        alt: slide.text,
        className: styles[slide.scaling]
      })
    ),
    React.createElement(TextWithAudio, {
      id: slide.id,
      theme: 'centeredText',
      className: slide.text || slide.audioSource ? styles.audioOrText : styles.noText,
      text: slide.text,
      audioSource: slide.audioSource
    })
  );
};

Slide.propTypes = process.env.NODE_ENV !== "production" ? Object.assign({}, slidePropTypes) : {};

var Slideshow = function (_Component) {
  _inherits(Slideshow, _Component);

  function Slideshow(props) {
    _classCallCheck(this, Slideshow);

    var _this = _possibleConstructorReturn(this, (Slideshow.__proto__ || Object.getPrototypeOf(Slideshow)).call(this, props));

    _this.handleNextButtonClick = function () {
      var setHideTemplateMenu = _this.context.setHideTemplateMenu;
      var slides = _this.props.slides;
      var currentSlideIndex = _this.state.currentSlideIndex;


      _this.setState({
        navbarIndex: getNext(currentSlideIndex, slides.length)
      });

      _this.animateNext();

      setHideTemplateMenu && setHideTemplateMenu(false);
    };

    _this.handlePreviousButtonClick = function () {
      var setHideTemplateMenu = _this.context.setHideTemplateMenu;
      var slides = _this.props.slides;
      var currentSlideIndex = _this.state.currentSlideIndex;


      _this.setState({
        navbarIndex: getPrevious(currentSlideIndex, slides.length)
      });

      _this.animatePrevious();

      setHideTemplateMenu && setHideTemplateMenu(false);
    };

    _this.handleNavBarClick = function (index) {
      var setHideTemplateMenu = _this.context.setHideTemplateMenu;
      var currentSlideIndex = _this.state.currentSlideIndex;


      if (index > currentSlideIndex) {
        _this.setState({
          overwriteNextSlide: index,
          navbarIndex: index
        }, function () {
          return _this.animateNext();
        });
      }

      if (index < currentSlideIndex) {
        _this.setState({
          overwritePreviousSlide: index,
          navbarIndex: index
        }, function () {
          return _this.animatePrevious();
        });
      }

      setHideTemplateMenu && setHideTemplateMenu(false);
    };

    _this.animateNext = function () {
      _this.$slidingElements.className = styles.slidingElements + ' ' + styles.animateLeft;
      _this.$slidingElements.dataset.animation = 'left';
    };

    _this.animatePrevious = function () {
      _this.$slidingElements.className = styles.slidingElements + ' ' + styles.animateRight;
      _this.$slidingElements.dataset.animation = 'right';
    };

    _this.onAnimationEnd = function () {
      var slides = _this.props.slides;
      var _this$state = _this.state,
          currentSlideIndex = _this$state.currentSlideIndex,
          overwriteNextSlide = _this$state.overwriteNextSlide,
          overwritePreviousSlide = _this$state.overwritePreviousSlide;


      _this.$slidingElements.className = '' + styles.slidingElements;

      if (_this.$slidingElements.dataset.animation === 'left') {
        _this.setState({
          currentSlideIndex: overwriteNextSlide !== false ? overwriteNextSlide : getNext(currentSlideIndex, slides.length),
          overwriteNextSlide: false
        });
      }

      if (_this.$slidingElements.dataset.animation === 'right') {
        _this.setState({
          currentSlideIndex: overwritePreviousSlide !== false ? overwritePreviousSlide : getPrevious(currentSlideIndex, slides.length),
          overwritePreviousSlide: false
        });
      }
    };

    _this.$slidingElements = null;

    _this.state = {
      currentSlideIndex: 0,
      overwriteNextSlide: false,
      overwritePreviousSlide: false,
      navbarIndex: 0
    };
    return _this;
  }

  _createClass(Slideshow, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var slides = this.props.slides;
      var _state = this.state,
          currentSlideIndex = _state.currentSlideIndex,
          overwriteNextSlide = _state.overwriteNextSlide,
          overwritePreviousSlide = _state.overwritePreviousSlide,
          navbarIndex = _state.navbarIndex;


      if (slides.length > 1) {
        var previousSlide = overwritePreviousSlide !== false ? overwritePreviousSlide : getPrevious(currentSlideIndex, slides.length);

        var nextSlide = overwriteNextSlide !== false ? overwriteNextSlide : getNext(currentSlideIndex, slides.length);

        var slidesToRender = [];
        slidesToRender.push(React.createElement(Slide, { slide: slides[previousSlide], key: slides[previousSlide].id + ' previous' }));
        slidesToRender.push(React.createElement(Slide, { slide: slides[currentSlideIndex], key: slides[currentSlideIndex].id + ' current' }));
        slidesToRender.push(React.createElement(Slide, { slide: slides[nextSlide], key: slides[nextSlide].id + ' next' }));

        return React.createElement(
          'div',
          { className: styles.container },
          React.createElement(CenteredButton, {
            className: styles.buttonLeft,
            theme: 'slideshow',
            icon: 'icon-chevron-left',
            onClick: this.handlePreviousButtonClick
          }),
          React.createElement(
            'div',
            {
              className: styles.mask
            },
            React.createElement(
              'div',
              {
                className: styles.slidingElements,
                ref: function ref(slidingElements) {
                  _this2.$slidingElements = slidingElements;
                },
                onAnimationEnd: this.onAnimationEnd
              },
              slidesToRender
            )
          ),
          React.createElement(
            'div',
            { className: styles.menu },
            React.createElement(NavBar, {
              amount: slides.length,
              current: navbarIndex,
              clickable: true,
              onChange: this.handleNavBarClick
            })
          ),
          React.createElement(CenteredButton, {
            className: styles.buttonRight,
            theme: 'slideshow',
            icon: 'icon-chevron-right',
            onClick: this.handleNextButtonClick
          })
        );
      }
      return React.createElement(
        'div',
        { className: styles.container },
        React.createElement(
          'div',
          {
            className: styles.mask
          },
          React.createElement(
            'div',
            {
              className: styles.slidingElements + ' ' + styles.center,
              ref: function ref(slidingElements) {
                _this2.$slidingElements = slidingElements;
              },
              onAnimationEnd: this.onAnimationEnd
            },
            React.createElement(Slide, { slide: slides[currentSlideIndex], key: slides[currentSlideIndex].id + ' current' })
          )
        )
      );
    }
  }]);

  return Slideshow;
}(Component);

export default Slideshow;


Slideshow.propTypes = process.env.NODE_ENV !== "production" ? Object.assign({}, slidePropTypes) : {};

Slideshow.defaultProps = {};

Slideshow.contextTypes = {
  setHideTemplateMenu: PropTypes.func
};